import { requirePermissionGuard } from "@/shared/rbac";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/dashboard/dochazka/")({
  beforeLoad: requirePermissionGuard("hca.dochazka.read"),
});
